module.exports = __webpack_public_path__ + "static/trojan-horse-719e9fe30e441d749d69fbcc7004a255.jpg";